module.exports = __webpack_public_path__ + "img/6.fa26db97.jpeg";